import React from 'react';
import { createContext } from 'react';

import { AlertCircle, AlertTriangle, CheckMarkCircle2 } from '@lyearn/icons';

import { SnackbarAppearance, SnackbarContextType, SnackbarIconStatus } from './types';

export const getDefaultIcon = (params: {
  appearance: SnackbarAppearance;
  iconStatus: SnackbarIconStatus;
}) => {
  const { appearance, iconStatus } = params;
  if (appearance === 'primary') {
    switch (iconStatus) {
      case 'success':
        return <CheckMarkCircle2 className="fill-current w-24 h-24 native:text-icon-success" />;
      case 'error':
        return <AlertCircle className="fill-current w-24 h-24 native:text-icon-error" />;
      default:
        return <CheckMarkCircle2 className="fill-current w-24 h-24 native:text-icon-white" />;
    }
  }

  if (appearance === 'error') {
    return <AlertTriangle className="w-24 h-24 native:text-icon-white" />;
  }
};

export const SnackbarContext = createContext<null | SnackbarContextType>(null);
